import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import axios from "axios";
import ExcludeSerialNumber from "../../pages/ExcludeSerialNumber";

interface PostExcludedSerialNumbersParams {
    documentReference: string,
    serialNumbers: string[]
}

export const postExcludedSerialNumbers = async ({
    documentReference,
    serialNumbers
}: PostExcludedSerialNumbersParams) => {
    const token = await fetchSimDocumentsToken();

    const config = {
        headers : {
            Authorization: `Bearer ${token}`
        }
    }

    await axios.post(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents/" + documentReference + "/ExcludedSerialNumbers",
        serialNumbers,
        config
    );
}

export const getExcludedSerialNumbers = async (documentReference: string) : Promise<string[]> => {
    const token = await fetchSimDocumentsToken();

    const config = {
        headers : {
            Authorization: `Bearer ${token}`
        }
    }

    const response = await axios.get(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents/" + documentReference + "/ExcludedSerialNumbers",
        config
    );

    const serialNumbers: string[] = response.data.serialNumbers;

    return serialNumbers?.filter((sn): sn is string => sn != null) ?? [];
}

export const deleteExcludedSerialNumbers = async (documentReference: string, serialNumbers: string[]) => {
    if (serialNumbers.length === 0) {
        return;
    }

    const token = await fetchSimDocumentsToken();

    const config = {
        headers : {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        data: serialNumbers
    }
    await axios.delete(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents/" + documentReference + "/ExcludedSerialNumbers",
        config
    );
}

interface ExcludedSerialNumbersDto {
    serialNumber: string;
    modelCode: string;
    productCompanyCode: string;
}